<template>
  <div class="container">
    <iframe :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      url: ''
    }
  },
  created() {
    this.getpushCollectionDetail()
  },
  methods: {
    getpushCollectionDetail() {
      API.getpushCollectionDetail({
        collectionId: this.$route.query.id
      }).then(res => {
        this.url = res?.data?.pdfUrl + '#toolbar=1&navpanes=1&scrollbar=1&print=0&comment=0&edit=0&modifymeta=0&fillform=0' || ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: calc(100vh - 50px);
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
